// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ll-3";
export var downloadButton = "_ll-4";
export var fileContainer = "_ll-9 _ll-7";
export var fileContainerBase = "_ll-7";
export var fileContainerFixedHeight = "_ll-8 _ll-7";
export var fileInfo = "_ll-5";
export var fileInfoWidthRestricted = "_ll-6";
export var fileType = "_ll-1";
export var fileTypeName = "_ll-2";
export var image = "_ll-0";
export var link = "_ll-b";
export var overflowEllipsis = "_ll-a";